import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CoreModule } from 'app/modules/core/core.module';
import { FuseConfirmationModule } from '@fuse/services/confirmation';
import { UserComponent } from 'app/layout/common/user/user.component';

@NgModule({
    declarations: [
        UserComponent
    ],
    imports     : [
        CommonModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        CoreModule,
        FuseConfirmationModule
    ],
    exports     : [
        UserComponent
    ]
})
export class UserModule
{
}
